import { render, staticRenderFns } from "./agreePreview.vue?vue&type=template&id=81920a72&scoped=true&"
import script from "./agreePreview.vue?vue&type=script&lang=js&"
export * from "./agreePreview.vue?vue&type=script&lang=js&"
import style0 from "./agreePreview.vue?vue&type=style&index=0&id=81920a72&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81920a72",
  null
  
)

export default component.exports